(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-bubble"] && !Shopify.designMode) return;
  try {
    /*
   * Rob Steins: Horizon's cart icon redraws the count from cart.item_count after every cart change (and from
   * sessionStorage on back/forward). Straight after, put the count back to "everything except the free Travel Care Kit".
   */
  (() => {
    if (window.rsKitCount) return;
    window.rsKitCount = true;
    const KIT = ['travel-care-kit', 'free-10-gift-card'];

    const fix = async () => {
      try {
        const cart = await window.rsFetchCart();
        const kit = cart.items.filter((item) => KIT.includes(item.handle)).reduce((sum, item) => sum + item.quantity, 0);
        if (!kit) return;
        const count = Math.max(0, cart.item_count - kit);
        for (const el of document.querySelectorAll('.cart-bubble__text-count')) {
          if (el.textContent.trim() !== '') el.textContent = String(count);
        }
        const stored = sessionStorage.getItem('cart-count');
        if (stored) sessionStorage.setItem('cart-count', JSON.stringify({ ...JSON.parse(stored), value: String(count) }));
      } catch (error) {
        /* the count just stays as Horizon drew it */
      }
    };

    document.addEventListener('shopify:cart:lines-update', (event) => {
      Promise.resolve(event.promise)
        .catch(() => {})
        .then(() => setTimeout(fix, 60));
    });
    window.addEventListener('pageshow', () => setTimeout(fix, 60));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    /*
   * Rob Steins: letter charms open with "A" pre-selected, so shoppers who never touch the picker get an A.
   * Until a letter is tapped, Add to cart / Buy now stop and ask for one instead.
   */
  (() => {
    if (window.rsLetterGuard) return;
    window.rsLetterGuard = true;

    const picked = new Set();

    const showUnpicked = () => {
      document.querySelectorAll('[data-rs-letter-pick]').forEach((fieldset) => {
        if (picked.has(fieldset.dataset.rsLetterPick)) return;
        fieldset.setAttribute('data-rs-unpicked', '');
        const value = fieldset.querySelector('legend .variant-option__swatch-value');
        if (value) value.textContent = 'Choose one';
      });
    };

    const markPicked = (event) => {
      const fieldset = event.target.closest?.('[data-rs-letter-pick]');
      if (!fieldset || !event.target.matches?.('input')) return;
      picked.add(fieldset.dataset.rsLetterPick);
      document.querySelectorAll(`[data-rs-letter-pick="${fieldset.dataset.rsLetterPick}"]`).forEach((el) => {
        el.removeAttribute('data-rs-unpicked');
        el.querySelector('.rs-letter-warn')?.setAttribute('hidden', '');
      });
    };

    const guard = (event) => {
      const form = event.target.closest?.('product-form-component');
      const productId = form?.dataset.productId;
      if (!productId || picked.has(productId)) return;
      const fieldsets = [...document.querySelectorAll(`[data-rs-letter-pick="${productId}"]`)];
      const fieldset = fieldsets.find((el) => el.closest('dialog[open]')) || fieldsets[0];
      if (!fieldset) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const warn = fieldset.querySelector('.rs-letter-warn');
      if (warn) {
        warn.removeAttribute('hidden');
        warn.classList.remove('rs-letter-warn--shake');
        void warn.offsetWidth;
        warn.classList.add('rs-letter-warn--shake');
      }
      fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    document.addEventListener('click', markPicked, true);
    document.addEventListener('change', markPicked, true);
    document.addEventListener('submit', guard, true);
    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest?.('.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]')) guard(event);
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showUnpicked);
    } else {
      showUnpicked();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
